module.exports = __webpack_public_path__ + "img/logos_customer_18.f49bcb77.svg";